import './front.scss';
import { HeadingFront } from './HeadingFront.js';

new HeadingFront( document ).init();
